import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import styles from "./ShopExperience.module.scss";
import {useMediaQuery} from "react-responsive";
import {Exponea} from "../../../../tracking/exponea";

const ShopExperience: React.FC = () => {
  const {t} = useTranslation();
  const [rating, setRating] = useState<undefined | number>(undefined);
  const optionalInputRef = useRef<HTMLInputElement>(null);
  const [isShowing, setIsShowing] = useState(true);
  const isMobile = useMediaQuery({
    query: "(max-width: 480px)",
  });

  const NumberBox: React.FC<{num: number}> = ({num}) => {
    return (
      <div
        className={`${styles.numberBox} ${num === rating ? styles.clicked : ""}`}
        onClick={() => {
          setRating(num);
        }}
      >
        {num}
      </div>
    );
  };

  if (!isShowing) {
    return null;
  }

  return (
    <section className={styles.container}>
      <div className={styles.wrapper}>
        <span
          className={`icon-close ${styles.closeIcon}`}
          onClick={() => {
            Exponea.trackClose("NPS _ Bestellabschlussseite");
            setIsShowing(false);
          }}
        />
        <div className={styles.title}>{t("checkout.shopRecommendationChance")}</div>
        <div className={styles.numbersWrapper}>
          {Array.from({length: isMobile ? 6 : 11}).map((_: any, index) => {
            return <NumberBox key={index} num={index} />;
          })}
        </div>
        <div className={styles.textWrapper}>
          <span>{t("general.veryUnlikely")}</span>
          <div className={styles.borderBar} />
          <span>{t("general.veryLikely")}</span>
        </div>
        {rating !== undefined && (
          <div className={styles.formWrapper}>
            <input
              type={"text"}
              className={styles.messageInput}
              placeholder={`${t("form.yourMessage")}${t("general.optional")}`}
              ref={optionalInputRef}
            />
            <button
              className={styles.submitButton}
              onClick={() => {
                Exponea.trackNPS({
                  type: "Checkout",
                  rating: isMobile ? rating * 2 : rating,
                  feedback: optionalInputRef.current?.value ?? "",
                });
                setIsShowing(false);
              }}
            >
              {t("checkout.sendRating")}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ShopExperience;
